Locations =
{
	init : function()
	{
		// Setup gallery
	    jQuery('.gallery-list').lightGallery({
	        thumbnail: true,
	        selector: 'li .hero a',
	    });
	}
};//end object literal faqList

jQuery(document).ready(function(jQuery){
	
	Locations.init();
	
});
